export default __webpack_public_path__ + "static/media/house.d552c3c8.png";